import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const BseFailedPopUp = (props) => {

    const handleCloseClick = () =>{
        window.location.reload()
    }

    return (
        <Modal isOpen={props.showPopUpText} toggle={props.toggleInfoPopup}>
            <ModalHeader toggle={()=> handleCloseClick()}></ModalHeader>
            <ModalBody className="succ-body">
                <div className='wrapper text-center'>
                    <div className='w-100'>
                        <img className="ml-auto mr-auto succ-img" src={process.env.REACT_APP_IMAGES_PATH + "Exclamation.webp"} alt='limitexcede-icon' />
                    </div>
                    <p className="offline-popup">Something went wrong!</p>
                    <p className="text-2 offline-popup-small">Please email us at connect@biddeasy.com or
                        call us at +91 8591871028/+91 8928250817
                        for further assistance”</p>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default BseFailedPopUp;
